import { render, staticRenderFns } from "./SaudeDaMulher.vue?vue&type=template&id=6ec92f10"
import script from "./SaudeDaMulher.vue?vue&type=script&lang=js"
export * from "./SaudeDaMulher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports